export class ToolboxQueryInfo {
    constructor(eventTypeId: string, seqNr: string | null) {
        this.eventTypeId = eventTypeId;
        this.seqNr = seqNr;
    }
    eventTypeId: string;
    seqNr: string | null;
}
